import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["percentage", "size", "breakpoints", "inverted", "shady", "square", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.big.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import Text from 'components/Text';
import Box from 'components/Box';
import { Disc, Wrapper } from 'components/IconDisc';
import { scalePresets } from 'components/CircleImage';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PercentageDisc = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var percentage = _ref.percentage,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    breakpoints = _ref.breakpoints,
    inverted = _ref.inverted,
    shady = _ref.shady,
    square = _ref.square,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeOverrideProps = scalePresets.big;
  var isBig = size === 'big';
  var fontSize = isBig ? 'xl' : 'xxs';
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
    ref: ref
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(Disc, _objectSpread(_objectSpread({}, sizeOverrideProps), {}, {
      inverted: inverted,
      shady: shady,
      square: square,
      scale: isBig ? 2 : 1,
      children: /*#__PURE__*/_jsx(Box, {
        pb: isBig ? 'xs' : 'xxxs',
        children: percentage || percentage === 0 ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            bold: true,
            fontSize: fontSize,
            children: percentage
          }), /*#__PURE__*/_jsx(Text, {
            fontSize: "xxxs",
            children: "%"
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          bold: true,
          fontSize: fontSize,
          children: "-"
        })
      })
    }))
  }));
});
PercentageDisc.displayName = 'PercentageDisc';
export default PercentageDisc;